import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as analytics from '../../services/analytics';
import find from 'lodash/find';
import get from 'lodash/get';
import isObject from 'lodash/isObject';
import merge from 'lodash/merge';
import { Formik } from 'formik';
import * as yup from 'yup';
import Downshift from 'downshift';
import classnames from 'classnames';
import SIC_CODES from '../../constants/sicCodes';
import './BOAEnrollmentBusinessTypeView.css';

const propTypes = {
  onSubmit: PropTypes.func,
};

class BOAEnrollmentBusinessTypeView extends PureComponent {
  constructor(props) {
    super(props);
    this.formValidationSchema = yup.object().shape({
      sicCode: yup
        .string()
        .notOneOf([''])
        .required(`Please select a business type to continue.`),
    });
    this.state = {
      isInProgress: false,
      isValid: this.formValidationSchema.isValidSync(this.initialFormValues),
    };
  }

  componentDidMount() {
    analytics.page('BOA - Enrollment Business Region');
  }

  handleInitialValidation = ({ initialValues }) => {
    return this.formValidationSchema.isValidSync(initialValues);
  };

  handleSubmit = (values) => {
    const { updateQuote, onSubmit, onNotifyError, quote } = this.props;
    const { sicCode } = values;
    this.setState({
      isInProgress: true,
    });

    const updatedQuote = merge({}, quote, {
      application: {
        answers: {
          sic_code: parseInt(sicCode),
        },
      },
    });
    updateQuote(updatedQuote)
      .then(onSubmit)
      .catch((error) => {
        this.setState({
          isInProgress: false,
        });
        onNotifyError(error);
      });
  };

  handleChange = ({ code }) => {
    const { handleChange } = this.form;
    this.setState({
      isValid: this.formValidationSchema.isValidSync({
        sicCode: code,
      }),
    });
    const mockEvent = {
      target: {
        value: code,
        name: 'sicCode',
      },
    };
    handleChange(mockEvent);
  };

  renderSelectedItem(item) {
    if (item) {
      const { code, name } = item;
      return (
        <>
          <div className="BOAEnrollmentBusinessTypeView-selectToggleName">
            {name}
          </div>
          <span className="BOAEnrollmentBusinessTypeView-selectToggleCode">
            {code}
          </span>
        </>
      );
    } else {
      return <>Select one</>;
    }
  }

  getDropdownListFromInput(inputValue) {
    return SIC_CODES.filter(
      ({ code, name }) =>
        !inputValue ||
        `${name.toLowerCase()}${code}`.includes(
          inputValue.toLowerCase().replace(/[^0-9a-z]/gi, '')
        )
    );
  }

  get initialFormValues() {
    const {
      quote: { application },
    } = this.props;
    return {
      sicCode: get(application, 'answers.sic_code', ''),
    };
  }

  render() {
    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-7 p-t-30">
            <h3 className="text-center semi-bold">
              What is the nature of the business and SIC code?
            </h3>
            <div className="card m-t-20">
              <div className="card-block">
                <div className="form-group">
                  <Formik
                    initialValues={this.initialFormValues}
                    isInitialValid={this.handleInitialValidation}
                    validationSchema={this.formValidationSchema}
                    onSubmit={this.handleSubmit}
                    innerRef={(c) => (this.form = c)}
                  >
                    {({ values, handleSubmit }) => {
                      return (
                        <form className="row" onSubmit={handleSubmit}>
                          <label className="col-md-3 text-uppercase">
                            Business Detail
                          </label>
                          <Downshift
                            onChange={this.handleChange}
                            itemToString={(value) =>
                              isObject(value) ? value.name : value
                            }
                            selectedItem={
                              find(
                                SIC_CODES,
                                (pair) => pair.code === values.sicCode
                              ) || null
                            }
                          >
                            {({
                              getInputProps,
                              getItemProps,
                              getLabelProps,
                              getToggleButtonProps,
                              isOpen,
                              inputValue = '',
                              highlightedIndex,
                              selectedItem,
                              toggleMenu,
                            }) => (
                              <div className="col-md-9">
                                <label
                                  htmlFor="sicCode"
                                  className="text-uppercase"
                                  {...getLabelProps()}
                                >
                                  Business Nature and SIC Code
                                </label>
                                <button
                                  type="button"
                                  className="BOAEnrollmentBusinessTypeView-selectToggle"
                                  data-testid="BOAEnrollmentBusinessTypeView-selectToggle"
                                  {...getToggleButtonProps()}
                                  onClick={() =>
                                    toggleMenu({
                                      inputValue: '',
                                    })
                                  }
                                >
                                  {this.renderSelectedItem(selectedItem)}
                                </button>
                                {isOpen ? (
                                  <div className="BOAEnrollmentBusinessTypeView-dropdownWrapper">
                                    <div className="BOAEnrollmentBusinessTypeView-dropdown">
                                      <div className="BOAEnrollmentBusinessTypeView-dropdownInputWrapper">
                                        <input
                                          {...getInputProps()}
                                          autoFocus={true}
                                          className="BOAEnrollmentBusinessTypeView-dropdownInput"
                                          name="sicCode"
                                        />
                                      </div>
                                      <div className="BOAEnrollmentBusinessTypeView-dropdownList">
                                        {this.getDropdownListFromInput(
                                          inputValue
                                        ).map((item, index) => (
                                          <div
                                            data-testid="BOAEnrollmentBusinessTypeView-dropdownListItem"
                                            {...getItemProps({
                                              key: `${item.code}${item.name}`,
                                              index,
                                              item,
                                              className: classnames(
                                                'BOAEnrollmentBusinessTypeView-dropdownListItem',
                                                {
                                                  'BOAEnrollmentBusinessTypeView-dropdownListItem--highlighted':
                                                    highlightedIndex === index,
                                                }
                                              ),
                                            })}
                                          >
                                            {item.name}
                                            <span className="BOAEnrollmentBusinessTypeView-dropdownListItemCode">
                                              {item.code}
                                            </span>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            )}
                          </Downshift>
                          <input
                            type="submit"
                            style={{ display: 'none' }}
                            ref={(c) => (this.inputSubmit = c)}
                          />
                        </form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <button
                className="btn btn-lg btn-complete"
                disabled={!this.state.isValid || this.state.isInProgress}
                onClick={() => this.inputSubmit.click()}
                type="button"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BOAEnrollmentBusinessTypeView.propTypes = propTypes;

export default BOAEnrollmentBusinessTypeView;
